import { useMissionsTranslation } from '../../../../ui/hooks';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const DeniedNoShowHoursStatus = () => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center', color: (theme) => theme.palette.grey[700] }, "data-test": 'denied-no-show-hours-status' },
        React.createElement(CancelIcon, { fontSize: 'small' }),
        React.createElement(Box, { sx: { display: 'flex', alignItems: 'baseline', flexWrap: 'wrap' } },
            React.createElement(Typography, { variant: 'body2' }, t('timeTracking.noShow')))));
};
